import form from './index.js'

// 获取消息 /notice/getNotice
export function getmessge(data) {
    return form.getrequest('/notice/getNotice', data)
}